import React, { useState, useEffect, useCallback } from "react";
import { Button, Form, Card, Row, Col, Container, Spinner, Alert, Badge } from 'react-bootstrap';
import ReactQuill from 'react-quill';
import Select from 'react-select';
import 'react-quill/dist/quill.snow.css';
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';
import Menu from '../../comum/Menu/menu.jsx';
import Footer from '../../comum/Footer/index.jsx';

function PortalCandidato() {
    const [loading, setLoading] = useState(false);
    const [arquivo, setArquivo] = useState(null);
    const [arquivoExistente, setArquivoExistente] = useState({ email: "", nome: "" });
    const [apresentacaoHTML, setApresentacaoHTML] = useState("");
    const [areasDisponiveis, setAreasDisponiveis] = useState([]);
    const [areasSelecionadas, setAreasSelecionadas] = useState([]);
    const [aceiteLGPD, setAceiteLGPD] = useState(false);
    const [dataAtualizacao, setDataAtualizacao] = useState(null);

    const handleFilhosChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            const novoEstado = { ...prev, [name]: value };

            // Lógica de formatação para o banco de dados [cite: 177]
            if (novoEstado.tem_filhos_select === "S") {
                novoEstado.tem_filhos = `SIM - ${novoEstado.filhos_quantidade}`;
            } else {
                novoEstado.tem_filhos = "NÃO";
                novoEstado.filhos_quantidade = 0; // Reseta a contagem se marcar Não
            }

            return novoEstado;
        });
    };

    const [formData, setFormData] = useState({
        nome_candidato: "",
        email_candidato: "",
        telefone_candidato: "",
        valor_pretensao: "",
        link_linkedin: "",
        dta_nascimento: "",
        estado_civil: "",
        escolaridade: "",
        familiar_floresta: "",
        tem_filhos_select: "N",
        filhos_quantidade: 0,
        tem_filhos: "NÃO",
        endereco_completo: "",
        cnh_categoria: "",
        ja_trabalhou_floresta: "Não",
        etnia_ibge: "",
        genero_identidade: "",
        loja_preferencia: ""

    });

    // --- FUNÇÃO PARA BUSCAR ÁREAS (Modularizada) ---
    const carregarAreas = useCallback(async () => {
        try {
            const res = await api.get('/externo/areas');
            const options = res.data.map(item => ({
                value: item.id_area,
                label: item.descricao
            }));
            setAreasDisponiveis(options);
        } catch (err) {
            console.error("Erro ao carregar áreas:", err);
        }
    }, []);

    // --- CARREGAMENTO INICIAL ---
    useEffect(() => {
        carregarAreas();
    }, [carregarAreas]);

    // --- FUNÇÃO PARA LIMPAR TELA E REBUSCAR ÁREAS ---
    const handleCancelar = () => {
        setFormData({
            nome_candidato: "",
            email_candidato: "",
            telefone_candidato: "",
            valor_pretensao: "",
            link_linkedin: "",
            dta_nascimento: "",
            estado_civil: "",
            escolaridade: "",
            familiar_floresta: "",
            tem_filhos: "",
            endereco_completo: "",
            cnh_categoria: "",
            ja_trabalhou_floresta: "Não",
            etnia_ibge: "",
            genero_identidade: "",
            loja_preferencia: ""
        });

        setApresentacaoHTML("");
        setAreasSelecionadas([]);
        setArquivo(null);
        setArquivoExistente({ email: "", nome: "" });
        setAceiteLGPD(false);
        setDataAtualizacao(null);

        // Busca novamente as áreas para garantir atualização
        carregarAreas();

        Swal.fire("Cancelado", "O formulário foi limpo e as áreas foram atualizadas.", "info");
    };

    // --- FUNÇÕES DE UTILIDADE ---
    const decodeBase64 = (str) => {
        try {
            if (!str) return "";
            return decodeURIComponent(escape(window.atob(str)));
        } catch (e) { return str; }
    };

    const handleBuscarEVerCurriculo = async (email, nomeArquivo) => {
        try {
            setLoading(true);
            console.log(email + nomeArquivo);
            // Busca o arquivo especificamente pelo e-mail
            const response = await api.get(`/rh/curriculos/arquivo?email=${email}`);

            // Visualização correta no console (use a vírgula, não o sinal de +)
            console.log('Resposta da API:', response.data);

            let base64Dados = "";

            // Caso 1: A API retornou uma lista (Array)
            if (Array.isArray(response.data) && response.data.length > 0) {
                const item = response.data[0];
                base64Dados = item.curriculo_blob || item.CURRICULO_BLOB;
            }
            // Caso 2: A API retornou um objeto direto
            else if (response.data) {
                base64Dados = response.data.curriculo_blob || response.data.CURRICULO_BLOB;
            }

            if (base64Dados) {
                // Reaproveita sua função original de processamento de Blob
                handleVerAnexo(base64Dados, nomeArquivo);
            } else {
                Swal.fire('Aviso', 'O registro foi encontrado, mas o campo do arquivo está vazio no servidor.', 'warning');
            }
        } catch (err) {
            console.error('Erro na requisição:', err);
            Swal.fire('Erro', 'Não foi possível conectar ao servidor para baixar o arquivo.', 'error');
        } finally {
            setLoading(false);
        }
    };

    const encodeBase64 = (str) => {
        try {
            if (!str) return "";
            const bytes = new TextEncoder().encode(str);
            let binary = "";
            bytes.forEach(b => binary += String.fromCharCode(b));
            return window.btoa(binary);
        } catch (e) { return ""; }
    };

    const handleVerAnexo = (base64Dados, nomeArquivo) => {
        try {
            if (!base64Dados) return Swal.fire('Erro', 'Conteúdo do arquivo não encontrado.', 'error');
            const base64Limpo = base64Dados.replace(/^.+,/, "").replace(/\s/g, "");
            const byteCharacters = atob(base64Limpo);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            let type = "application/octet-stream";
            const ext = nomeArquivo?.toLowerCase() || "";
            if (ext.endsWith(".pdf")) type = "application/pdf";
            else if (ext.endsWith(".png")) type = "image/png";
            else if (ext.endsWith(".jpg") || ext.endsWith(".jpeg")) type = "image/jpeg";
            const blob = new Blob([byteArray], { type: type });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
        } catch (err) {
            Swal.fire('Erro', 'Falha ao processar o arquivo.', 'error');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNomeChange = (e) => {
        setFormData({ ...formData, nome_candidato: e.target.value.toUpperCase() });
    };

    const handleEmailChange = (e) => {
        setFormData({ ...formData, email_candidato: e.target.value.toLowerCase() });
    };

    const handleTelefoneChange = (e) => {
        let value = e.target.value.replace(/\D/g, "");
        if (value.length <= 11) {
            value = value.replace(/^(\d{2})(\d)/g, "($1) $2");
            value = value.replace(/(\d)(\d{4})$/, "$1-$2");
            setFormData({ ...formData, telefone_candidato: value });
        }
    };

    const validarEmail = (email) => {
        return String(email).toLowerCase().match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
    };

    // --- LÓGICA DE AUTO-PREENCHIMENTO ---
    const checkEmailExistente = async (email) => {
        if (!email || !validarEmail(email)) return;

        try {
            const res = await api.get(`/externo/candidato/${email}`);
            const d = Array.isArray(res.data) ? res.data[0] : (res.data.dados || res.data);


            if (d && d.nome_candidato) {
                Swal.fire({
                    title: 'Currículo localizado!',
                    html: `Olá <b>${d.nome_candidato}</b>, já temos o seu cadastro.<br>Deseja carregar os dados para atualização?`,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Sim, carregar',
                    cancelButtonText: 'Não, limpar e-mail',
                    allowOutsideClick: false
                }).then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para desmembrar o campo do banco
                        const valorBanco = d.tem_filhos || "NÃO";
                        const ehSim = valorBanco.toUpperCase().includes("SIM");
                        const qtd = ehSim ? valorBanco.replace(/[^0-9]/g, '') : 0;
                        setFormData({
                            nome_candidato: (d.nome_candidato || "").toUpperCase(),
                            email_candidato: (d.email_candidato || "").toLowerCase(),
                            telefone_candidato: d.telefone_candidato || "",
                            valor_pretensao: d.valor_pretensao || "",
                            link_linkedin: d.link_linkedin || "",
                            dta_nascimento: d.dta_nascimento ? d.dta_nascimento.substring(0, 10) : "",
                            estado_civil: d.estado_civil || "",
                            escolaridade: d.escolaridade || "",
                            familiar_floresta: d.familiar_floresta || "",
                            // Novos campos auxiliares alimentados pelo banco
                            tem_filhos_select: ehSim ? "S" : "N",
                            filhos_quantidade: qtd || 0,
                            tem_filhos: valorBanco, // Mantém o valor original para o banco
                            endereco_completo: d.endereco_completo || "",
                            cnh_categoria: d.cnh_categoria || "",
                            ja_trabalhou_floresta: d.ja_trabalhou_aqui === 'S' ? 'Sim' : 'Não',
                            etnia_ibge: d.etnia_ibge || "",
                            genero_identidade: d.genero_identidade || "",
                            loja_preferencia: d.loja_preferencia || ""
                        });

                        if (d.dta_alteracao) {
                            const [dataParte, horaParte] = d.dta_alteracao.split('T');
                            const [ano, mes, dia] = dataParte.split('-');
                            const horaFormatada = horaParte.substring(0, 8);
                            setDataAtualizacao(`${dia}/${mes}/${ano} ${horaFormatada}`);
                        }

                        if (d.texto_apresentacao) {
                            setApresentacaoHTML(decodeBase64(decodeBase64(d.texto_apresentacao)));
                        }

                        const idsString = d.areas_ids || d.AREAS_IDS;
                        if (idsString) {
                            const idsDoBanco = String(idsString).split(',').map(id => id.trim());
                            const selecionadas = areasDisponiveis.filter(opt =>
                                idsDoBanco.includes(String(opt.value))
                            );
                            setAreasSelecionadas(selecionadas);
                        }
                        setArquivoExistente({
                            email: d.email_candidato,
                            nome: d.nome_arquivo, // O botão depende deste campo agora
                        });
                        setAceiteLGPD(d.lgpd_aceite === 'S');
                    } else {
                        setFormData(prev => ({ ...prev, email_candidato: "" }));
                        setDataAtualizacao(null);
                    }
                });
            }
        } catch (err) {
            console.error("Erro ao buscar dados:", err);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validarEmail(formData.email_candidato)) return Swal.fire("E-mail Inválido", "Insira um e-mail válido.", "warning");
        if (!aceiteLGPD) return Swal.fire("Atenção", "Aceite os termos da LGPD.", "warning");
        if (areasSelecionadas.length === 0) return Swal.fire("Atenção", "Selecione ao menos uma área.", "warning");

        if (!arquivo && !arquivoExistente.base64) {
            return Swal.fire("Atenção", "Anexe o seu currículo em PDF.", "warning");
        }

        setLoading(true);

        const enviarDados = async (arquivoBase64 = null, nomeArquivo = null) => {
            const payload = {
                ...formData,
                valor_pretensao: parseFloat(formData.valor_pretensao || 0),
                texto_apresentacao: encodeBase64(apresentacaoHTML),
                areas: areasSelecionadas.map(a => a.value),
                curriculo_base64: arquivoBase64 || arquivoExistente.base64,
                nome_arquivo: nomeArquivo || arquivoExistente.nome || "curriculo.pdf",
                ja_trabalhou_aqui: formData.ja_trabalhou_floresta === 'Sim' ? 'S' : 'N'
            };

            try {
                await api.post('/externo/candidatar', payload);
                await Swal.fire("Sucesso!", "Dados gravados com sucesso.", "success");
                window.location.reload();
            } catch (err) {
                Swal.fire("Erro", "Falha ao enviar dados.", "error");
            } finally { setLoading(false); }
        };

        if (arquivo) {
            const reader = new FileReader();
            reader.readAsDataURL(arquivo);
            reader.onload = () => enviarDados(reader.result.split(',')[1], arquivo.name);
        } else {
            enviarDados();
        }
    };

    return (
        <div className="d-flex flex-column" style={{ minHeight: '100vh', backgroundColor: '#f4f7f6' }}>
            <Menu modulo="RH" />
            <Container className="py-5 mt-5">
                <Card className="border-0 shadow-sm">
                    <Card.Header className="bg-primary text-white text-center">
                        <h5 className="mb-0">Portal do Candidato - Trabalhe Conosco</h5>
                    </Card.Header>
                    <Card.Body className="p-4">
                        <Form onSubmit={handleSubmit}>

                            <h6 className="fw-bold text-primary border-bottom pb-2 mb-3">DADOS PESSOAIS</h6>

                            {dataAtualizacao && (
                                <Row className="mb-3">
                                    <Col md={4}>
                                        <Form.Label className="small fw-bold text-muted">ÚLTIMA ATUALIZAÇÃO DO CADASTRO</Form.Label>
                                        <Form.Control
                                            type="text"
                                            value={dataAtualizacao}
                                            disabled
                                            className="bg-light border-0 text-primary fw-bold"
                                        />
                                    </Col>
                                </Row>
                            )}

                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Label className="small fw-bold">E-MAIL</Form.Label>
                                    <Form.Control
                                        required
                                        type="email"
                                        name="email_candidato"
                                        value={formData.email_candidato}
                                        onBlur={e => checkEmailExistente(e.target.value)}
                                        onChange={handleEmailChange}
                                        placeholder="Seu melhor e-mail"
                                    />
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="small fw-bold">NOME COMPLETO</Form.Label>
                                    <Form.Control required placeholder="NOME EM MAIÚSCULO" name="nome_candidato" value={formData.nome_candidato} onChange={handleNomeChange} />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">DATA DE NASCIMENTO</Form.Label>
                                    <Form.Control required type="date" name="dta_nascimento" value={formData.dta_nascimento} onChange={handleInputChange} />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">ESTADO CIVIL</Form.Label>
                                    <Form.Select required name="estado_civil" value={formData.estado_civil} onChange={handleInputChange}>
                                        <option value="">Selecione...</option>
                                        <option value="Solteiro">Solteiro</option>
                                        <option value="Casado">Casado</option>
                                        <option value="Divorciado">Divorciado</option>
                                        <option value="Viúvo">Viúvo</option>
                                        <option value="União Estável">União Estável</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">GÊNERO</Form.Label>
                                    <Form.Select required name="genero_identidade" value={formData.genero_identidade} onChange={handleInputChange}>
                                        <option value="">Selecione...</option>
                                        <option value="Cis Gênero">Cis Gênero</option>
                                        <option value="Trans Gênero">Trans Gênero</option>
                                        <option value="Não Binário">Não Binário</option>
                                        <option value="Prefiro não informar">Prefiro não informar</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">DECLARO-ME (IBGE)</Form.Label>
                                    <Form.Select required name="etnia_ibge" value={formData.etnia_ibge} onChange={handleInputChange}>
                                        <option value="">Selecione...</option>
                                        <option value="Preto">Preto</option>
                                        <option value="Pardo">Pardo</option>
                                        <option value="Indígena">Indígena</option>
                                        <option value="Branco">Branco</option>
                                        <option value="Amarelo">Amarelo</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            <h6 className="fw-bold text-primary border-bottom pb-2 mb-3 mt-4">INFORMAÇÕES COMPLEMENTARES</h6>
                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Label className="small fw-bold">ESCOLARIDADE</Form.Label>
                                    <Form.Select required name="escolaridade" value={formData.escolaridade} onChange={handleInputChange}>
                                        <option value="">Selecione...</option>
                                        <option value="Fundamental Incompleto">Fundamental Incompleto</option>
                                        <option value="Fundamental Completo">Fundamental Completo</option>
                                        <option value="Ensino Médio Incompleto">Ensino Médio Incompleto</option>
                                        <option value="Ensino Médio Completo">Ensino Médio Completo</option>
                                        <option value="Superior Incompleto">Superior Incompleto</option>
                                        <option value="Superior Completo">Superior Completo</option>
                                        <option value="Pós-Graduação / Especialização">Pós-Graduação / Especialização</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">POSSUI CNH?</Form.Label>
                                    <Form.Select required name="cnh_categoria" value={formData.cnh_categoria} onChange={handleInputChange}>
                                        <option value="Não possuo.">Não possuo.</option>
                                        <option value="A">A</option>
                                        <option value="B">B</option>
                                        <option value="C">C</option>
                                        <option value="D">D</option>
                                        <option value="E">E</option>
                                        <option value="AB">AB</option>
                                        <option value="AD">AD</option>
                                        <option value="AE">AE</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">JÁ TRABALHOU AQUI?</Form.Label>
                                    <Form.Select required name="ja_trabalhou_floresta" value={formData.ja_trabalhou_floresta} onChange={handleInputChange}>
                                        <option value="Não">Não</option>
                                        <option value="Sim">Sim</option>
                                    </Form.Select>
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={4}>
                                    <Form.Label className="small fw-bold">FAMILIAR NA EMPRESA?</Form.Label>
                                    <Form.Control name="familiar_floresta" value={formData.familiar_floresta} onChange={handleInputChange} placeholder="Nome e Unidade" />
                                </Col>
                                <Col md={4} className="mb-3">
                                    <Form.Label className="small fw-bold">TEM FILHOS?</Form.Label>
                                    <Form.Select
                                        name="tem_filhos_select"
                                        value={formData.tem_filhos_select}
                                        onChange={handleFilhosChange}
                                    >
                                        <option value="N">NÃO</option>
                                        <option value="S">SIM</option>
                                    </Form.Select>
                                </Col>

                                {/* Exibição condicional: só aparece se o select for "S" */}
                                {formData.tem_filhos_select === "S" && (
                                    <Col md={4} className="mb-3">
                                        <Form.Label className="small fw-bold">QUANTIDADE DE FILHOS</Form.Label>
                                        <Form.Control
                                            type="number"
                                            name="filhos_quantidade"
                                            min="1"
                                            max="20"
                                            value={formData.filhos_quantidade}
                                            onChange={handleFilhosChange}
                                            placeholder="1 a 20"
                                        />
                                    </Col>
                                )}

                                <Col md={4}>
                                    <Form.Label className="small fw-bold">Linkedin.com</Form.Label>
                                    <Form.Control name="link_linkedin" value={formData.link_linkedin} onChange={handleInputChange} placeholder="https://br.linkedin.com/in/meuperfil" />
                                </Col>
                            </Row>

                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold">ENDEREÇO COMPLETO</Form.Label>
                                <Form.Control required name="endereco_completo" value={formData.endereco_completo} onChange={handleInputChange} placeholder="Rua, número, bairro, cidade..." />
                            </Form.Group>

                            <h6 className="fw-bold text-primary border-bottom pb-2 mb-3 mt-4">VAGA E LOCAL DE INTERESSE</h6>
                            <Row className="mb-3">
                                <Col md={12}>
                                    <Form.Label className="small fw-bold">ÁREAS DE INTERESSE (CARGOS)</Form.Label>
                                    <Select
                                        isMulti
                                        options={areasDisponiveis}
                                        placeholder="Selecione as áreas..."
                                        value={areasSelecionadas}
                                        onChange={setAreasSelecionadas}
                                        className="basic-multi-select"
                                    />
                                </Col>
                            </Row>

                            <Row className="mb-3">
                                <Col md={6}>
                                    <Form.Label className="small fw-bold">LOJA MAIS PRÓXIMA A SUA RESIDÊNCIA</Form.Label>
                                    <Form.Select required name="loja_preferencia" value={formData.loja_preferencia} onChange={handleInputChange}>
                                        <option value="">Selecione a unidade...</option>
                                        <option value="Loja Volta Redonda - Amaral Peixoto">Volta Redonda - Amaral Peixoto</option>
                                        <option value="Loja Volta Redonda - São Lucas">Volta Redonda - São Lucas</option>
                                        <option value="Loja Volta Redonda - Aterrado">Volta Redonda - Aterrado</option>
                                        <option value="Loja Volta Redonda - Retiro">Volta Redonda - Retiro</option>
                                        <option value="Loja Volta Redonda - Vila">Volta Redonda - Vila Santa Cecília</option>
                                        <option value="Loja Barra Mansa">Barra Mansa</option>
                                        <option value="Loja Resende">Resende</option>
                                        <option value="Loja Valença">Valença</option>
                                        <option value="Loja Pinheiral">Pinheiral</option>
                                        <option value="CDP Barra Mansa">Barra Mansa - Dutra</option>
                                        <option value="CD Volta Redonda">Volta Redonda - Três Poços</option>
                                    </Form.Select>
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">PRETENSÃO SALARIAL</Form.Label>
                                    <Form.Control type="number" name="valor_pretensao" value={formData.valor_pretensao} onChange={handleInputChange} placeholder="0.00" />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold">TELEFONE</Form.Label>
                                    <Form.Control required value={formData.telefone_candidato} onChange={handleTelefoneChange} placeholder="(00) 00000-0000" />
                                </Col>
                            </Row>

                            <Form.Group className="mb-4">
                                <Form.Label className="small fw-bold">RESUMO PROFISSIONAL / APRESENTAÇÃO</Form.Label>
                                <ReactQuill
                                    theme="snow"
                                    value={apresentacaoHTML}
                                    onChange={setApresentacaoHTML}
                                    style={{ height: '150px', marginBottom: '70px' }} // Aumente aqui
                                />
                            </Form.Group>

                            <Form.Group className="mb-4" style={{ position: 'relative', zIndex: 5 }}>
                                <Form.Label className="small fw-bold">
                                    CURRÍCULO (PDF)
                                    {arquivoExistente.base64 && <Badge bg="success" className="ms-2">Curriculo PDF</Badge>}
                                </Form.Label>

                                <Form.Control
                                    type="file"
                                    accept=".pdf"
                                    onChange={e => setArquivo(e.target.files[0])}
                                />

                                {arquivoExistente.nome && !arquivo && (
                                    <div className="mt-2 d-flex align-items-center border p-2 bg-light rounded">
                                        <span className="small text-muted me-auto">
                                            Curriculo Enviado: {arquivoExistente.nome}
                                        </span>
                                        <Button
                                            variant="outline-primary"
                                            size="sm"
                                            onClick={() => handleBuscarEVerCurriculo(arquivoExistente.email, arquivoExistente.nome)}
                                        >
                                            📄 Visualizar Curriculo Enviado
                                        </Button>
                                    </div>
                                )}
                            </Form.Group>

                            <Alert variant="light" className="border small">
                                <h6><b>TERMOS E PRIVACIDADE (LGPD)</b></h6>
                                <Form.Check
                                    type="checkbox"
                                    label="Aceito o tratamento dos meus dados profissionais para recrutamento."
                                    required
                                    checked={aceiteLGPD}
                                    onChange={e => setAceiteLGPD(e.target.checked)}
                                />
                            </Alert>

                            <div className="d-flex gap-3 mt-4">
                                <Button
                                    variant="outline-secondary"
                                    size="lg"
                                    type="button"
                                    className="w-50 fw-bold"
                                    onClick={handleCancelar}
                                    disabled={loading}
                                >
                                    CANCELAR / LIMPAR
                                </Button>

                                <Button
                                    variant="primary"
                                    size="lg"
                                    type="submit"
                                    className="w-50 fw-bold"
                                    disabled={loading}
                                >
                                    {loading ? <Spinner size="sm" animation="border" /> : "GRAVAR E ENVIAR"}
                                </Button>
                            </div>
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
            <Footer />
        </div>
    );
}

export default PortalCandidato;